import React, { useState, useContext } from 'react'
import { Box, Select, TextArea, Button, BubbleLoader } from '@deal/components'
import styles from './styles.css'
import { Link } from 'react-router-dom'
import { AnalyticsContext } from '#src/containers/Analytics'
import { toast } from 'react-toastify'

interface FeedbackFormProps {
  onRequestClose: () => void
  sourceKey: Tracking.FeedbackSourceKey
}

const FeedbackForm: React.SFC<FeedbackFormProps> = ({ onRequestClose, sourceKey }) => {
  const analytics = useContext(AnalyticsContext)
  const [feedbackType, setFeedbackType] = useState<string>()
  const [feedback, setFeedback] = useState<string>()
  const [disappointmentLevel, setDissapointmentLevel] = useState<string>()
  const [suggestion, setSuggestion] = useState<string>()
  const [canContact, setCanContact] = useState<string>()
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false)

  const feedbackTypeOptions = [
    { value: '', label: 'Select one...', disabled: true, selected: !feedbackType },
    { value: 'COMPLIMENT', label: 'Compliment' },
    { value: 'COMPLAINT', label: 'Complaint' },
    { value: 'SUGGESTION', label: 'Suggestion' },
    { value: 'OTHER', label: 'Other' }
  ]
  const disappointmentLevelOptions = [
    { value: '', label: 'Select one...', disabled: true, selected: !disappointmentLevel },
    { value: 'VERY_DISAPPOINTED', label: 'Very disappointed' },
    { value: 'SOMEWHAT_DISAPPOINTED', label: 'Somewhat disappointed' },
    { value: 'NOT_DISAPPOINTED', label: 'Not disappointed' }
  ]
  const canContactOptions = [
    { value: '', label: 'Select one...', disabled: true, selected: !canContact },
    { value: 'YES', label: 'Yes' },
    { value: 'NO', label: 'No' }
  ]

  const handleSubmit = (
    feedbackType: string | undefined,
    feedback: string | undefined,
    disappointmentLevel: string | undefined,
    suggestion: string | undefined,
    canContact: string | undefined
  ) => {
    if (!feedbackType) {
      return toast.error('Select the type of feedback you would like to leave.')
    }
    if (!feedback) {
      return toast.error('Feedback is required.')
    }
    if (analytics) {
      analytics.events.feedbackSubmitted({
        feedback_type: feedbackType,
        feedback: feedback,
        disappointment_level: disappointmentLevel,
        suggestion: suggestion,
        can_contact: canContact,
        source_key: sourceKey
      })
    }
    setFeedbackSubmitted(true)
    setTimeout(() => {
      onRequestClose()
      toast.success('Thank you for your feedback.')
    }, 500)
  }

  return (
    <>
      <div className={styles.customerSupport}>
        If you are looking for help related to an order, please{' '}
        <Link to={`/support`} className={styles.link}>
          go here{' '}
        </Link>
        for customer support
      </div>
      <div className={styles.formContainer}>
        <Box.Item className={styles.inputContainer}>
          <Select
            label="What type of feedback would you like to leave?"
            onChange={e => setFeedbackType(e.target.value)}
            value={feedbackType}
            display="standard"
            options={feedbackTypeOptions}
            selectClassName={styles.select}
          />
        </Box.Item>
        <Box.Item className={styles.inputContainer}>
          <label>Leave your feedback below </label>
          <TextArea rows={5} value={feedback} onChange={e => setFeedback(e.target.value)} />
        </Box.Item>
        <Box.Item className={styles.inputContainer}>
          <Select
            label="How disappointed would you be if you could no longer use Curated?"
            onChange={e => setDissapointmentLevel(e.target.value)}
            value={disappointmentLevel}
            display="standard"
            options={disappointmentLevelOptions}
            selectClassName={styles.select}
          />
        </Box.Item>
        <Box.Item className={styles.inputContainer}>
          <label>What could we do to make Curated better? </label>
          <TextArea rows={5} value={suggestion} onChange={e => setSuggestion(e.target.value)} />
        </Box.Item>
        <Box.Item className={styles.inputContainer}>
          <Select
            label="Can we contact you to learn more about your experience?"
            onChange={e => setCanContact(e.target.value)}
            value={canContact}
            display="standard"
            options={canContactOptions}
            selectClassName={styles.select}
          />
        </Box.Item>
        <Button
          className={styles.button}
          size="small"
          disabled={feedbackSubmitted}
          variant="primary"
          onClick={() =>
            handleSubmit(feedbackType, feedback, disappointmentLevel, suggestion, canContact)
          }
        >
          {feedbackSubmitted ? <BubbleLoader /> : 'Submit'}
        </Button>
      </div>
    </>
  )
}

export default FeedbackForm
